import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["enabled", "titleText", "children"];
import React from 'react';
import { Expander } from "../expander";
import { jsx as ___EmotionJSX } from "@emotion/core";
export var OptionalExpander = function OptionalExpander(_ref) {
  var enabled = _ref.enabled,
      titleText = _ref.titleText,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  if (enabled) {
    return ___EmotionJSX(Expander, _extends({}, rest, {
      titleText: titleText,
      contentSpacing: "S100"
    }), children);
  }

  return ___EmotionJSX(React.Fragment, null, children);
};